import React, {Fragment} from "react";
import {postData} from "../../../utils/request";
import Button from "../Button";
import classNames from "classnames";
import {isTrue} from "../../../utils/other";
import {loadComponent, loadComponentById} from "../../../utils/components";
import Modules from "./Modules";
import ContentLoader from "../../layout/ContentLoader";
import NodeEditor from "./NodeEditor";
import AttributeEditor from "./AttributeEditor";
import parse_url from "locutus/php/url/parse_url";
import Select from "../Select";

// https://mediag.com/blog/popular-screen-resolutions-designing-for-all/
const PixelSizes = [
    {name: "iPhone XR", width: 828, height: 1792},
    {name: "iPhone XS", width: 1125, height: 2436},
    {name: "iPhone XS Max", width: 1242, height: 2688},
    {name: "iPhone X", width: 1125, height: 2436},
    {name: "iPhone 8 Plus", width: 1080, height: 1920},
    {name: "iPhone 8", width: 750, height: 1334},
    {name: "iPhone 7 Plus", width: 1080, height: 1920},
    {name: "iPhone 7", width: 750, height: 1334},
    {name: "iPhone 6 Plus/6S Plus", width: 1080, height: 1920},
    {name: "iPhone 6/6S", width: 750, height: 1334},
    {name: "iPhone 5", width: 640, height: 1136},
    {name: "iPod Touch", width: 640, height: 1136},
    {name: "iPad Pro", width: 2048, height: 2732},
    {name: "iPad Third & Fourth Generation", width: 1536, height: 2048},
    {name: "iPad Air 1 & 2", width: 1536, height: 2048},
    {name: "iPad Mini 2 & 3", width: 1536, height: 2048},
    {name: "iPad Mini", width: 768, height: 1024},

    {name: "Nexus 6P", width: 1440, height: 2560},
    {name: "Nexus 5X", width: 1080, height: 1920},
    {name: "Google Pixel 4 XL", width: 1440, height: 869},
    {name: "Google Pixel 4", width: 1080, height: 2280},
    {name: "Google Pixel 3a XL", width: 1080, height: 2160},
    {name: "Google Pixel 3a", width: 1080, height: 2220},
    {name: "Google Pixel 3 XL", width: 1440, height: 2960},
    {name: "Google Pixel 3", width: 1080, height: 2160},
    {name: "Google Pixel 2 XL", width: 1440, height: 2560},
    {name: "Google Pixel XL", width: 1440, height: 2560},
    {name: "Google Pixel", width: 1080, height: 1920},
    {name: "Samsung Galaxy Note 10+", width: 1440, height: 3040},
    {name: "Samsung Galaxy Note 10", width: 1080, height: 2280},
    {name: "Samsung Galaxy Note 9", width: 1440, height: 2960},
    {name: "Samsung Galaxy Note 5", width: 1440, height: 2560},
    {name: "LG G5", width: 1440, height: 2560},
    {name: "One Plus 3", width: 1080, height: 1920},
    {name: "Samsung Galaxy S9+", width: 1440, height: 2960},
    {name: "Samsung Galaxy S9", width: 1440, height: 2960},
    {name: "Samsung Galaxy S8+", width: 1440, height: 2960},
    {name: "Samsung Galaxy S8", width: 1440, height: 2960},
    {name: "Samsung Galaxy S7 Edge", width: 1440, height: 2560},
    {name: "Samsung Galaxy S7", width: 1440, height: 2560},

    {name: "Nexus 9", width: 1536, height: 2048},
    {name: "Nexus 7 (2013)", width: 1200, height: 1920},
    {name: "Pixel C", width: 1800, height: 2560},
    {name: "Samsung Galaxy Tab 10", width: 800, height: 1280},
    {name: "Chromebook Pixel", width: 2560, height: 1700},
].map((option,idx) => ({...option, id: idx}));

const ViewPorts = [
    {name: "iPhone XR", width: 414, height: 896},
    {name: "iPhone XS", width: 375, height: 912},
    {name: "iPhone XS Max", width: 414, height: 896},
    {name: "iPhone X", width: 375, height: 812},
    {name: "iPhone 8 Plus", width: 414, height: 736},
    {name: "iPhone 8", width: 375, height: 667},
    {name: "iPhone 7 Plus", width: 414, height: 736},
    {name: "iPhone 7", width: 375, height: 667},
    {name: "iPhone 6 Plus/6S Plus", width: 414, height: 736},
    {name: "iPhone 6/6S", width: 375, height: 667},
    {name: "iPhone 5", width: 320, height: 568},
    {name: "iPod Touch", width: 320, height: 568},
    {name: "iPad Pro", width: 1024, height: 1366},
    {name: "iPad Third & Fourth Generation", width: 768, height: 1024},
    {name: "iPad Air 1 & 2", width: 768, height: 1024},
    {name: "iPad Mini 2 & 3", width: 768, height: 1024},
    {name: "iPad Mini", width: 768, height: 1024},

    {name: "Nexus 6P", width: 412, height: 732},
    {name: "Nexus 5X", width: 412, height: 732},
    {name: "Google Pixel 4 XL", width: 412, height: 869},
    {name: "Google Pixel 4", width: 412, height: 869},
    {name: "Google Pixel 3a XL", width: 412, height: 824},
    {name: "Google Pixel 3a", width: 412, height: 846},
    {name: "Google Pixel 3 XL", width: 412, height: 847},
    {name: "Google Pixel 3", width: 412, height: 824},
    {name: "Google Pixel 2 XL", width: 412, height: 732},
    {name: "Google Pixel XL", width: 412, height: 732},
    {name: "Google Pixel", width: 412, height: 732},
    {name: "Samsung Galaxy Note 10+", width: 412, height: 869},
    {name: "Samsung Galaxy Note 10", width: 412, height: 869},
    {name: "Samsung Galaxy Note 9", width: 360, height: 740},
    {name: "Samsung Galaxy Note 5", width: 480, height: 853},
    {name: "LG G5", width: 480, height: 853},
    {name: "One Plus 3", width: 480, height: 853},
    {name: "Samsung Galaxy S9+", width: 360, height: 740},
    {name: "Samsung Galaxy S9", width: 360, height: 740},
    {name: "Samsung Galaxy S8+", width: 360, height: 740},
    {name: "Samsung Galaxy S8", width: 360, height: 740},
    {name: "Samsung Galaxy S7 Edge", width: 360, height: 640},
    {name: "Samsung Galaxy S7", width: 360, height: 640},

    {name: "Nexus 9", width: 768, height: 1024},
    {name: "Nexus 7 (2013)", width: 600, height: 960},
    {name: "Pixel C", width: 900, height: 1280},
    {name: "Samsung Galaxy Tab 10", width: 800, height: 1280},
    {name: "Chromebook Pixel", width: 1280, height: 850},
].map((option,idx) => ({...option, id: idx}));

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const JSScript = document.createElement('script');
    JSScript.setAttribute("type", "text/javascript");
    JSScript.setAttribute("src", "https://cdn.jsdelivr.net/npm/srcdoc-polyfill@1.0.0/srcdoc-polyfill.min.js");
    document.head.appendChild(JSScript);
}

export default class MjmlField extends React.Component {

    state = {
        isLoading: true,
        html: "",
        attributes: {},
        parts: [],
        fullScreen: false,
        screenSize: null,
        scale: 100,
    };

    constructor(props) {
        super(props);
        this.calculateHtml();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value + "" !== "" + prevProps.value) {
            this.calculateHtml();
        }
    }

    calculateHtml = async () => {
        this.abort && this.abort();
        let abort = false;
        this.abort = () => abort = true;
        if (this.props.value) {
            const parse = await this.parse();
            this.mjml = postData({
                action: "Newsletter.render",
                engine: "mjml",
                mjml: parse.mjml
            }, {}, {showError: false});
            this.mjml.then((res) => {
                if (abort) return;
                this.setState({
                    html: res.html,
                    parts: parse.parts,
                    attributes: parse.attributes,
                });
            });
            this.mjml.catch((e) => {
                if (abort) return;
                console.log(e);
            })
        } else {
            if (abort) return;
            this.setState({
                html: '',
                parts: [],
                attributes: [],
            });
        }
    }

    parse = async () => {
        const parts = [];
        const attributes = {};
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');

        //console.log(dom.documentElement.outerHTML);

        await Promise.all(Object.keys(AttributeEditor.attributes).map(async (attributeName) => {
            const attributeNodes = [];
            dom.querySelectorAll("mj-head mj-attributes " + attributeName).forEach((attribute) => attributeNodes.push(attribute));
            attributes[attributeName] = await AttributeEditor.attributes[attributeName].parse(attributeNodes);
        }));

        const sections = [];
        dom.querySelectorAll("mj-include[id]").forEach((section) => {
            sections.push(section);
            parts.push({
                component: "MjmlPart",
                id: section.getAttribute("id"),
                variables: {},
                fixed: isTrue(section.getAttribute("data-fixed")),
                head: section.parentNode.nodeName === "mj-head",
                excluded: isTrue(section.getAttribute("data-excluded"))
            });
        });
        this.setState({isLoading: true});
        for (const [index, section] of sections.entries()) {
            const component = await loadComponentById("MjmlPart", section.getAttribute("id"));
            const mjmlSection = new DOMParser().parseFromString("<mjml>" + component.mjml + "</mjml>", 'text/xml');
            const dataNodes = [];
            mjmlSection.querySelectorAll(":scope [data-id]").forEach((dataNode) => {
                dataNodes.push(dataNode);
            });
            for (const dataNode of dataNodes) {
                const variableName = dataNode.getAttribute("data-id");
                const type = dataNode.nodeName;
                const variables = section.querySelectorAll(":scope > data-variable[id='" + variableName + "']");
                parts[index].variables[variableName] = {type: dataNode.nodeName};
                parts[index].variables[variableName].data = await NodeEditor.nodes[type].parse(dataNode, variables);
                parts[index].variables[variableName].data = parts[index].variables[variableName].data || {};
                dataNode.removeAttribute("data-id");
            }
            let wrapper;
            if (section.parentNode.nodeName === "mj-body") {
                wrapper = dom.createElement("mj-wrapper");
                const domId = "section_" + new Date().getTime();
                wrapper.setAttribute("css-class", domId);
                parts[index].domId = domId;
            } else {
                wrapper = dom.createDocumentFragment();
            }
            mjmlSection.querySelector("mjml").childNodes.forEach((child) => {
                wrapper.appendChild(child);
            });
            section.parentNode.replaceChild(wrapper, section);
        }

        const images = [];
        dom.querySelectorAll("mj-body mj-image").forEach((image) => images.push(image));
        await Promise.all(images.map(async (image) => {
            const id = image.getAttribute("id");
            if (id) {
                const component = await loadComponentById("figure", id);
                image.setAttribute("src", component.url);
                image.removeAttribute("id");
            } else {
                if (!image.getAttribute("src")) {
                    image.parentNode.removeChild(image);
                }
            }
        }));

        const links = [];
        dom.querySelectorAll("mj-body [href]").forEach((link) => links.push(link));
        await Promise.all(links.map(async (link) => {
            const href = link.getAttribute("href");
            if (!isNaN(href)) {
                try {
                    const component = await loadComponentById("url", href);
                    link.setAttribute("href", component.url);
                } catch (e) {
                    console.log(e);
                }
            }
            link.setAttribute("target", "_blank");
        }));

        const components = [];
        dom.querySelectorAll("mj-body component").forEach((component) => components.push(component));
        await Promise.all(components.map(async (component) => {
            const type = component.getAttribute("type");
            if (type !== undefined) {
                if (type === "link") {
                    const link = dom.createElement("a");
                    let presetData = component.getAttribute("presetdata");
                    let filter = component.getAttribute("filter");
                    if (presetData) {
                        presetData = JSON.parse(presetData);
                    }
                    if (filter) {
                        filter = JSON.parse(filter);
                    }
                    const href = presetData?.url || component.getAttribute("id");
                    if (href && !isNaN(href)) {
                        try {
                            const component = await loadComponentById("url", href);
                            link.setAttribute("href", component.url);
                        } catch (e) {
                            console.log(e);
                        }
                    } else if (!href && filter) {
                        try {
                            const component = await loadComponent("url", {filter});
                            link.setAttribute("href", component.url);
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        link.setAttribute("href", href);
                    }
                    link.setAttribute("target", "_blank");
                    //link.setAttribute("href", "javascript:void(0);");
                    link.innerHTML = component.innerHTML;
                    component.parentNode.replaceChild(link, component);
                }
            }
        }));
        this.setState({isLoading: false});

        //console.log(dom.documentElement.outerHTML);

        return {mjml: dom.documentElement.outerHTML, parts, attributes};
    }

    isFullScreen = (value) => {
        return value === 'on' || isTrue(value);
    }

    saveChanges = (value) => {
        if (this.props.saveChanges) {
            this.props.saveChanges(this.props.name, value);
        }
    }

    onAttributeChanged = (attributeName, attribute) => {
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
        const attributeNodes = [];
        dom.querySelectorAll("mjml mj-head mj-attributes " + attributeName).forEach((attribute) => attributeNodes.push(attribute));
        AttributeEditor.attributes[attributeName].onAttributeChanged(attributeNodes, attributeName, attribute);
        this.saveChanges(dom.documentElement.outerHTML);
    }

    onSortEnd = async ({oldIndex, newIndex}) => {
        if (oldIndex !== newIndex) {
            const oldPosition = oldIndex;
            const distance = Math.abs(oldIndex - newIndex);
            const newPosition = (oldIndex - newIndex) > 0 ? oldPosition - distance : oldPosition + distance;
            let direction = 0;
            if (oldIndex > newIndex) {
                direction = 1;
            }
            const newSort = [];

            const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
            const sections = [];
            dom.querySelectorAll("mjml mj-include[id]").forEach((section) => sections.push(section));

            sections.forEach((item, index) => {
                if (index < newPosition && oldPosition !== index) {
                    //console.log('lower');
                    //console.log(item.getAttribute("id"));
                    newSort.push(item.cloneNode(true));
                } else if (index === newPosition) {
                    //console.log('equal');
                    //console.log(item.getAttribute("id"));
                    if (direction > 0) {
                        newSort.push(sections[oldPosition].cloneNode(true));
                        newSort.push(item.cloneNode(true));
                    } else {
                        newSort.push(item.cloneNode(true));
                        newSort.push(sections[oldPosition].cloneNode(true));
                    }
                } else if (index > newPosition && oldPosition !== index) {
                    //console.log('higher');
                    //console.log(item.getAttribute("id"));
                    newSort.push(item.cloneNode(true));
                }
            });
            //console.log(newSort.map((include) => include.getAttribute("id")));

            dom.querySelectorAll("mjml mj-include[id]").forEach((section, index) => section.parentNode.replaceChild(newSort[index], section));

            //console.log(dom.documentElement.outerHTML);
            this.saveChanges(dom.documentElement.outerHTML);
        }
    }

    onPartRemove = (removeIndex) => {
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
        let removed = false;
        dom.querySelectorAll("mjml mj-include[id]").forEach((section, index) => {
            if (removed) return;
            if (index === removeIndex) {
                section.parentNode.removeChild(section);
                removed = true;
            }
        });
        this.saveChanges(dom.documentElement.outerHTML);
    }

    onPartInsert = (partIndex, position, partId) => {
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
        const part = dom.createElement("mj-include");
        part.setAttribute("id", partId);

        dom.querySelectorAll("mjml mj-include[id]").forEach((section, index) => {
            if (index === partIndex) {
                if(position < 0) {
                    section.parentNode.insertBefore(part, section);
                } else if (position > 0) {
                    // https://stackoverflow.com/questions/4793604/how-to-insert-an-element-after-another-element-in-javascript-without-using-a-lib
                    // insertAfter
                    section.parentNode.insertBefore(part, section.nextSibling);
                }
            }
        });
        this.saveChanges(dom.documentElement.outerHTML);
    }

    onPartPaste = (partIndex) => {
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
        
        dom.querySelectorAll("mjml mj-include[id]").forEach((section, index) => {
            if (index === partIndex) {
                section.parentNode.insertBefore(section.cloneNode(true), section.nextSibling);
            }
        });
        this.saveChanges(dom.documentElement.outerHTML);
    }

    onVariableChanged = (partIndex, variableName, variable, document = null) => {
        const dom = document || (new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml'));
        dom.querySelectorAll("mjml mj-include[id]").forEach((section, index) => {
            if (index === partIndex) {
                section.querySelectorAll(":scope > data-variable[id='" + variableName + "']").forEach((variableNode) => {
                    variableNode.parentNode.removeChild(variableNode);
                });
                const variableNode = dom.createElement("data-variable");
                variableNode.setAttribute("id", variableName);
                section.appendChild(variableNode);
                NodeEditor.nodes[this.state.parts[partIndex].variables[variableName].type].onVariableChanged(variableNode, variableName, variable);
            }
        });
        !document && this.saveChanges(dom.documentElement.outerHTML);
    }

    onVariablesChanged = (partIndex, variables) => {
        const dom = new DOMParser().parseFromString(this.props.value || "<mjml></mjml>", 'text/xml');
        Object.keys(variables).map((variableName) => {
            const variable = variables[variableName];
            this.onVariableChanged(partIndex, variableName, variable, dom);
        });
        this.saveChanges(dom.documentElement.outerHTML);
    }

    onFocusSection = (partIndex) => {
        if (this.iframe) {
            this.onFocusSectionTimeout && clearTimeout(this.onFocusSectionTimeout);
            const document = this.iframe.contentWindow.document;
            //const window = this.iframe.contentWindow;
            let focusStyle = document.head.querySelector("style#focusStyle");
            if (!focusStyle) {
                focusStyle = document.createElement("style");
                focusStyle.setAttribute("id", "focusStyle");
                focusStyle.setAttribute("rel", "stylesheet");
                focusStyle.setAttribute("type", "text/css");
                document.head.appendChild(focusStyle);
            }
            if (this.state.parts[partIndex].domId) {
                document.querySelector("." + this.state.parts[partIndex].domId).scrollIntoView();
                focusStyle.innerHTML = `
                .${this.state.parts[partIndex].domId} {
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse-red 2s;
}

@keyframes pulse-red {
  0% {
    //transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.9);
  }

  70% {
    //transform: scale(1);
    box-shadow: 0 0 0 5px rgba(255, 82, 82, 0);
  }

  100% {
    //transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
                `;
            } else {
                focusStyle.innerHTML = '';
            }
            this.onFocusSectionTimeout = setTimeout(() => {
                focusStyle.innerHTML = '';
            }, 1500);
        }
    }

    attachDomEvents = () => {
        //const document = this.iframe.contentWindow.document;
    }

    onSelectSection = () => {

    }

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }

        let content;
        if (this.state.isLoading) {
            content = <div className="loader-holder"><ContentLoader />{/*<div className="loader"><div className="load" style={{width: (100 - (this.state.isLoading / this.state.isLoadings * 100)) + '%'}} /></div>*/}</div>;
        } else {
            content = <div className="flex-grow-1">
                <div className="screen-controls d-flex justify-content-center align-items-center">
                    <div style={{minWidth: '200px'}}>
                        <Select
                            storeType="local"
                            isClearable={true}
                            options={ViewPorts}
                            labelKey="name"
                            valueKey="id"
                            label={false}
                            placeholder="Képernyőméret"
                            value={this.state.screenSize}
                            saveChanges={(field, screenSize) => {
                                this.setState({
                                    screenSize
                                });
                            }}
                        />
                    </div>
                    {this.state.screenSize ? <div style={{minWidth: '200px'}}>
                        <Select
                            storeType="local"
                            options={[...Array(50).keys()].reverse().map((key, idx) => ({id: idx+51, name: (idx+51) + "%", scale: idx+51}))}
                            labelKey="name"
                            valueKey="id"
                            label={false}
                            placeholder="Nagyítás"
                            value={this.state.scale}
                            saveChanges={(field, scale) => {
                                this.setState({
                                    scale: scale || 100
                                });
                            }}
                        />
                    </div> : null}
                </div>
                <div className={classNames("screen", this.state.screenSize ? "d-flex justify-content-center" : null)}>
                    <div className={this.state.screenSize ? "controlled" : null} style={this.isFullScreen(this.state.fullScreen) && this.state.screenSize ? {width: this.state.screenSize?.width, height: this.state.screenSize?.height, transform: "scale(" + (this.state.scale?.scale / 100) + ")"} : null}>
                        <iframe ref={(iframe) => {this.iframe = iframe; this.attachDomEvents()}} srcDoc={this.state.html} onLoad={async () => {
                            const document = this.iframe.contentWindow.document;
                            //const window = this.iframe.contentWindow;
                            let clickCountStyle = document.head.querySelector("style#teszt");
                            let urlClicks = null;
                            if (this.props.componentId) {
                                urlClicks = await loadComponent("componentlist", {
                                    component: "StatisticsNewsletterClicks",
                                    itemsperpage: 0,
                                    filter: {field: "newsletter", value: this.props.componentId}
                                });
                            }
                            if (!clickCountStyle) {
                                clickCountStyle = document.createElement("style");
                                clickCountStyle.setAttribute("id", "clickCountStyle");
                                clickCountStyle.setAttribute("rel", "stylesheet");
                                clickCountStyle.setAttribute("type", "text/css");
                                document.head.appendChild(clickCountStyle);
                            }
                            clickCountStyle.innerHTML = `
                            a[data-click-count] {
                              position: relative;
                              z-index: 100 !important;
                            }
                                            
                                            a::before,
                            a[data-click-count]::after {
                                position: absolute;
                                left: 50%;
                                bottom: calc(100% + 5px); 
                            
                                opacity: 0;
                                visibility: hidden;
                                pointer-events: none;
                            
                                transition: 0.1s;
                                will-change: transform;
                            }
                            
                            a[data-click-count]::before {
                                content: '0';
                                max-width: 300px;
                                width: max-content;
                                width: -moz-max-content;
                            
                                padding: 10px 18px;
                                border-radius: 10px;
                                background-color: rgba(50, 50, 50, 1);
                                box-shadow: var(--default-box-shadow);
                            
                                color: #fff;
                                font-size: 0.75rem;
                                text-align: center;
                                white-space: pre-wrap;
                            
                                transform: translate(-50%, -5px) scale(0.5);
                            }
                            
                            a[data-click-count]::after {
                                content: '';
                                border-style: solid;
                                border-width: 5px 5px 0 5px; 
                                border-color: rgba(50, 50, 50, 1) transparent transparent transparent;
                            
                                transform-origin: top;   
                                transition-duration: 0s;
                                transform: translateX(-50%) scaleY(0);
                            }
                            a[data-click-count]:hover::before,
                            a[data-click-count]:hover::after {
                                visibility: visible;
                                opacity: 1;
                            }
                            
                            a[data-click-count]:hover::before {
                                transition-delay: 0.1s;
                                transform: translate(-50%, -5px) scale(1);
                            }
                            
                            a[data-click-count]:hover::after {
                                transition-delay: 0.1s;
                                transition-duration: 0.05s;
                                transform: translateX(-50%) scaleY(1);
                            }`;

                            let linkcounter = 0;
                            let url = parse_url(window.location.href);
                            document.body.querySelectorAll("a").forEach((a) => {
                                let inner = false;
                                let href = a.getAttribute("href");
                                if (href?.indexOf("/") === 0) {
                                    inner = true;
                                } else if (href?.indexOf(url.scheme + "://" + url.host + url.path) === 0) {
                                    inner = true;
                                }
                                if (inner) {
                                    linkcounter++;
                                    const link = urlClicks?.items?.find((item) => item.link_id + "" === "" + linkcounter);
                                    a.setAttribute('data-link-id', linkcounter);
                                    let qty = link?.qty || 0;
                                    a.setAttribute('data-click-count', qty);
                                    clickCountStyle.innerHTML += `
                                        a[data-click-count="${qty}"]::before {
                                         content: "${qty}";
                                        }
                                    `;
                                }
                            })
                        }}
                        />
                    </div>
                </div>
            </div>;
        }
        return (
            <div className={classNames("mjml-editor", {"full-screen": this.isFullScreen(this.state.fullScreen)})}>
                <label htmlFor={this.props.name} className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
                <div className="toolbar">
                    {(this.props.toolbar || []).map((btn, key) => {
                        if (typeof btn !== 'string') {
                            if (typeof btn === "object" && btn.type && btn.props) {
                                return <btn.type
                                    key={key}
                                    ref={btn.ref}
                                    {...btn.props}
                                    value={this.props.value}
                                    disabled={btn.props.disabled || this.props.disabled || this.state.isLoading}
                                />
                            } else if (btn instanceof Function) {
                                const Comp = btn;
                                return <Comp
                                    key={key}
                                    value={this.props.value}
                                    disabled={this.props.disabled || this.state.isLoading}
                                />
                            }
                        }
                    })}
                </div>
                <div className="editing">
                    <div className="build">
                        <Modules
                            disabled={this.props.disabled || this.state.isLoading}
                            attributes={this.state.attributes}
                            parts={this.state.parts}
                            component={this.props.component}
                            componentId={this.props.componentId}
                            className="parts"
                            onSelectSection={this.onSelectSection}
                            onFocusSection={this.onFocusSection}
                            onAttributeChanged={this.onAttributeChanged}
                            onPartInsert={this.onPartInsert}
                            onPartPaste={this.onPartPaste}
                            onVariableChanged={this.onVariableChanged}
                            onVariablesChanged={this.onVariablesChanged}
                            onSortEnd={this.onSortEnd}
                            onPartRemove={this.onPartRemove}
                        />
                    </div>
                </div>
                {content}
                <Button
                    block={true}
                    tooltip={!this.state.fullScreen ? "Szerkesztés" : "Bezárás"}
                    className="full-screen-button"
                    color="default"
                    onClick={() => this.setState({fullScreen: !this.state.fullScreen})}
                    icon={{lib: "fas", name: !this.state.fullScreen ? "pencil-alt" : "times"}}
                />
            </div>
        );
    }
}